export const getOrigin = () => {
  try {
    return window.parent.location.origin;
  } catch (e) {
    return '*';
  }
}